import { StorageAmountCardController } from './storage-amount-card.controller'

function storageAmountCard () {
  return {
    restrict: 'E',
    scope: {
      simplified: '<'
    },
    templateUrl: '/admin/directives/storage-amount-card/storage-amount-card-directive.html?$$REVISION$$',
    controller: StorageAmountCardController
  }
}

export { storageAmountCard }
